<template>
  <div class="config_hang_rule_wraper">
    <div class="config_hang_rule_name">
      <div class="config_hang_rule_xuhao">
        {{ ServeSceneRuleListIndex + 1 }}
      </div>
      <div class="config_hang_rule_name_wraper">
        <ellipsis-tooltip class="hang_rule_region_name" :text="userOneRule.sceneDeviceDisplayName"></ellipsis-tooltip>
        <!-- {{ userOneRule.productCode }} -->
        <ellipsis-tooltip class="hang_rule_device_name" :text="userOneRule.sceneDeviceDescription"></ellipsis-tooltip>
      </div>
    </div>
    <!-- 设备延时时间的显示 -->
    <div class="config_hang_rule_time">
      <input type="text" v-model="userOneRuleDelayMin" onkeyup="value=value.replace(/[^\d\.]/g,'')" />
      <span>分</span>
      <input type="text" placeholder="0" v-model="userOneRuleDelayS" onkeyup="value=value.replace(/[^\d\.]/g,'')" />
      <span>秒</span>
    </div>
    <!-- 设备状态字段的显示 -->
    <div class="config_hang_rule_state" @click="configRuleStateClickHandle(1)">
      <div v-if="computedShowOpenState != ''" class="z_ellipsis1">
        {{ computedShowOpenState }}
      </div>
      <div v-if="computedShowOpenStateValue != ''" class="z_ellipsis1">
        {{ computedShowOpenStateValue }}
      </div>
      <div v-if="computedShowOpenStateValue1 != ''" class="z_ellipsis1">
        {{ computedShowOpenStateValue1 }}
      </div>
      <div v-if="computedShowOpenStateValue2 != ''" class="z_ellipsis1">
        {{ computedShowOpenStateValue2 }}
      </div>
      <div v-if="computedShowOpenStateValue3 != ''" class="z_ellipsis1">
        {{ computedShowOpenStateValue3 }}
      </div>
    </div>

    <!-- 需要密码验证的提示 -->
    <div v-if="userOneRule.passwordState === 1" class="mimatishi_config_rele_hang">
      <img src="~assets/img/config/mimatishi.png" alt />
    </div>
    <!-- 打开关闭img按钮的显示 -->
    <!-- computedShowOpenState === '打开' || computedShowOpenState === '关闭' || computedShowOpenState === '开/升'
      || computedShowOpenState === '关/降' || computedShowOpenState === '停止' || computedShowOpenState === '布防'
    || computedShowOpenState === '撤防' ||-->
    <!-- 场景规则需要开关按钮显示的设备类型 -->
    <div v-if="
      deviceTypeJudge(
        '01',
        '02',
        '05',
        '06',
        '07',
        '08',
        '010',
        '013',
        '014',
        '015',
        '016',
        '017',
        '018',
        '021',
        '020',
        '022',
        '025',
        '026',
        '029',
        '027',
        '028'
      )
    " class="config_hang_rule_switch_state_img" @click="configRuleStateClickHandle(2)">
      <img v-show="computedSwitchImgShowState" src="~assets/img/config/zhu_kai.png" alt />
      <img v-show="!computedSwitchImgShowState" src="~assets/img/config/zhu_guan.png" alt />
    </div>
    <!-- 场景规则不需要开关按钮显示的设备类型 -->
    <div v-else class="config_hang_rule_xiugai_state_img" @click="configRuleStateClickHandle(1)">
      <img src="~assets/img/config/xiugai.png" alt />
      <!-- <img v-show="computedShowOpenState === '关闭' " src="~assets/img/config/zhu_guan.png" alt /> -->
    </div>

    <!-- 行的下划线 -->
    <div class="config_rule_hang_fen_ge_xian z_ellipsis1" v-if="fenGeXian === true"></div>
  </div>
</template>

<script>
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
import {
  showStateText,
  smartSceneRuleImgChange,
  isSimpleSwitchSceneRule
} from 'common/tool'
import EllipsisTooltip from 'components/common/ellipsis-tooltip/ellipsis-tooltip'
// import { publicDeviceTypeJudge } from "components/content/contro-view/device-view/device-item-view-js";
export default {
  data() {
    return {
      ///直接使用服务端获得 的数据进行修改和处理
      userOneRule: this.oneRule, ///其实这里是把地址赋值过去了，所以是实时修改的服务器传来的缓存数据
      //  {
      //   openState: 0,
      //   openStateValue: 0,
      //   openStateValue1: 0,
      //   openStateValue2: 0,
      //   delayTime: 0,
      //   deviceId: "406476431837761536",
      //   productCode: "01",
      //   regionName: "默认区域",
      //   remark: "通道1"
      // }
      userOneRuleDelayMin: 0, ////规则的延时时间分钟
      userOneRuleDelayS: 0
      // showState:{
      //   openState:"",
      //   openStateValue:"",
      //   openStateValue1:"",
      //   openStateValue2:""
      // }
    }
  },
  props: {
    fenGeXian: {
      type: Boolean,
      default: true
    },
    oneRule: Object, ////一个场景下的一条规则  服务端传来的数据
    ServeSceneRuleListIndex: Number
  },
  components: {
    EllipsisTooltip
  },
  computed: {
    computedShowOpenState() {
      ////设备状态及控制字段1 的对象显示
      console.log('11111111')
      return showStateText(
        1,
        this.userOneRule.openState,
        this.userOneRule.productCode,
        this.userOneRule
      )
    },
    computedShowOpenStateValue() {
      console.log('22222222222')
      ////设备状态及控制字段2 的对象显示
      return showStateText(
        2,
        this.userOneRule.openStateValue,
        this.userOneRule.productCode,
        this.userOneRule
      )
    },
    computedShowOpenStateValue1() {
      console.log('3333333333')
      ////设备状态及控制字段3 的对象显示
      return showStateText(
        3,
        this.userOneRule.openStateValue1,
        this.userOneRule.productCode,
        this.userOneRule
      )
    },
    computedShowOpenStateValue2() {
      console.log('4444444444')
      ////设备状态及控制字段4 的对象显示
      return showStateText(
        4,
        this.userOneRule.openStateValue2,
        this.userOneRule.productCode,
        this.userOneRule
      )
    },
    computedShowOpenStateValue3() {
      return showStateText(
        5,
        this.userOneRule.openStateValue3,
        this.userOneRule.productCode,
        this.userOneRule
      )
    },
    computedSwitchImgShowState() {
      ////  双色调光和三色调光的 开关按钮状态判断
      if (this.userOneRule.productCode === '025') {
        if (
          this.userOneRule.openState != 0 ||
          this.userOneRule.openStateValue != 0
        ) {
          return true
        } else {
          return false
        }
      } else if (this.userOneRule.productCode === '026') {
        if (
          this.userOneRule.openState != 0 ||
          this.userOneRule.openStateValue != 0 ||
          this.userOneRule.openStateValue1 != 0 ||
          this.userOneRule.openStateValue2 != 0
        ) {
          return true
        } else {
          return false
        }
      } else if (this.userOneRule.productCode === '029') {
        return this.userOneRule.openState != 0 ||
          this.userOneRule.openStateValue != 0 ||
          this.userOneRule.openStateValue1 != 0 ||
          this.userOneRule.openStateValue2 != 0 ||
          this.userOneRule.openStateValue3 != 0
      } else {
        ////通用产品
        if (
          this.computedShowOpenState === '打开' ||
          this.computedShowOpenState === '开/升' ||
          this.computedShowOpenState === '布防'
        ) {
          return true
        } else if (
          this.computedShowOpenState === '关闭' ||
          this.computedShowOpenState === '停止' ||
          this.computedShowOpenState === '撤防' ||
          this.computedShowOpenState === '关/降'
        ) {
          return false
        }
      }
    }
  },
  methods: {
    configDeviceState() { },
    configRuleStateClickHandle(data) {
      //规则点击时弹出控制窗
      ///判断当前设备类型  是否和后面的'01' , '021' , '05'相同，相同返回true
      if (data === 1) {
        ///说明是状态按钮按下的  正常处理
        if (isSimpleSwitchSceneRule(this.userOneRule)) {
          deviceStateFlip(this.userOneRule) ///对设备的状态0和1进行翻转
          // controlBtnRequestHandle(this.userControlData, this.oneDevice); ///控制请求服务端的公共方法
          return
        } else {
          console.log(this.oneRule);
          this.$showControlToast('config', this.oneRule)
        }
      } else if (data === 2) {
        ///说明是开关IMG按钮按下的
        // console.log(this.userOneRule.openState)
        smartSceneRuleImgChange(this.userOneRule, this.oneRule)
      }
    },
    deviceTypeJudge(...type) {
      ///判断设备类型
      return publicDeviceTypeJudge(this.userOneRule.productCode, ...type)
    }
  },
  watch: {
    userOneRuleDelayMin(Val) {
      /// 对延时时间分钟变量的监测及转换

      if (Val === '' || isNaN(parseInt(Val))) {
        ///如果用户删除完了
        Val = 0
        this.userOneRuleDelayMin = Number(Val)
      }
      ///如果不是
      this.userOneRuleDelayMin = Number(Val)
      this.userOneRule.delayTime = Number(
        parseInt(Val) * 60 + this.userOneRuleDelayS
      )
      if (this.userOneRule.delayTime >= 30000) {
        ////对输入的最大值做一个限制
        this.userOneRule.delayTime = 30000
        this.userOneRuleDelayMin = Number(
          parseInt(this.userOneRule.delayTime / 60)
        ) ////根据用户输入秒正确显示分钟
        this.userOneRuleDelayS = Number(this.userOneRule.delayTime % 60)
        this.$toast('最大输入500分钟！')
      }

      console.log(this.userOneRule.delayTime)
    },
    userOneRuleDelayS(Val) {
      /// 对延时时间秒变量的监测及转换
      if (Val === '' || isNaN(parseInt(Val))) {
        Val = 0
        // this.userOneRuleDelayS = Number(Val);
      }
      this.userOneRuleDelayS = Number(Val)
      this.userOneRule.delayTime = Number(
        parseInt(Val) + this.userOneRuleDelayMin * 60
      )
      if (this.userOneRule.delayTime >= 30000) {
        ////对输入的最大值做一个限制
        this.userOneRule.delayTime = 30000
        this.$toast('最大输入500分钟！')
      }

      if (this.userOneRule.delayTime >= 60) {
        this.userOneRuleDelayMin = Number(
          parseInt(this.userOneRule.delayTime / 60)
        ) ////根据用户输入秒正确显示分钟
        this.userOneRuleDelayS = Number(this.userOneRule.delayTime % 60)
      }
      console.log(this.userOneRule.delayTime)
    }
  },
  mounted() {
    console.log(this.userOneRule.delayTime)
    this.userOneRuleDelayMin = parseInt(this.userOneRule.delayTime / 60) ////拿到服务器返回的延时时间
    this.userOneRuleDelayS = this.userOneRule.delayTime % 60
  }
}

/**使用说明
 *
 *
 */
</script>

<style>
.config_hang_rule_wraper {
  height: 90px;
  width: 100%;
  line-height: 60px;
  padding: 0px 10px;
  color: #282828;
  font-size: 16px;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;

  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  justify-items: center;
}

.config_rule_hang_fen_ge_xian {
  display: inline-block;
  width: 1143px;
  height: 1px;
  background-color: #f2f2f2;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

/* .config_hang_rule_wraper:hover {
  box-shadow: 1px -1px 4px var(--primary-color) inset;
} */

.config_hang_rule_name {
  position: relative;

  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.config_hang_rule_xuhao {
  width: 30px;
}

.config_hang_rule_name_wraper {
  /* display:inline-block;
  height: 80px;
  line-height: 80px; */

  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: flex-start;
}

.config_hang_rule_name_wraper div {
  width: 250px;
  height: 30px;
  line-height: 30px;
}

.hang_rule_region_name {
  font-size: 18px;
}

.hang_rule_device_name {
  font-size: 16px;
  color: #666666;
}

.config_hang_rule_time {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;

  width: 400px;
}

.config_hang_rule_time:hover {
  color: #40a8fb;
}

.config_hang_rule_time input {
  width: 80px;
  font-size: 16px;
  color: #666666;
}

.config_hang_rule_time input:focus {
  color: #40a8fb;
  outline: none;
  border: 1px solid #40a8fb;
}

.config_hang_rule_state {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  color: #666666;
  width: 100px;
}

.config_hang_rule_state:hover {
  color: #40a8fb;
}

.config_hang_rule_state div {
  height: 18px;
  width: 100px;
  line-height: 18px;

  font-size: 14px;
}

.config_hang_rule_switch_state_img {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 46px;
}

.config_hang_rule_switch_state_img img {
  height: 28px;
  width: 46px;
}

.config_hang_rule_xiugai_state_img img {
  height: 28px;
  width: 46px;
}

.config_hang_rule_xiugai_state_img {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 46px;
}

.config_hang_rule_xiugai_state_img img {
  height: 28px;
  width: 28px;
}

.mimatishi_config_rele_hang {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background-color: #f2f2f2;
  position: absolute;
  right: 65px;
  top: 34px;
}

.mimatishi_config_rele_hang img {
  height: 16px;
  width: 16px;

  position: absolute;
  right: 4px;
  top: 4px;
}
</style>
